import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { StyledDeletedUserBadge } from './deleted-user-badge.styled';

interface Props {
	className?: string;
}

export const DeletedUserBadge: FC<Props> = ({ className }) => {
	const { t } = useTranslation();

	return (
		<StyledDeletedUserBadge className={className}>{t('common.deletedUser')}</StyledDeletedUserBadge>
	);
};
